$(function() {
    var log = console.log.bind(console);

    $(document).pjax('a[js-ajax]', '#body',{
        timeout: 2000,
        fragment: '#body',
        type: 'POST'
    });

    $(document).on('pjax:send', function (event) {
        $('body').addClass('loading');
        log('pjax:send');
    });

    $(document).on('pjax:complete', function () {
        $('body').removeClass('loading');
        log('pjax:complete');
    });

    $(document).on('pjax:timeout', function (event) {
        log('pjax:timeout');
    });

    $(document).on('pjax:beforeReplace', function (contents, options) {
        log('pjax:beforeReplace',contents);
    });

    function isHhistoryApiAvailable() {
        return !!(window.history && history.pushState);
    }
    function get_data(page_url, history_push) {
        $.ajax({
            url: page_url,
            beforeSend: function () {

            },
            success: function (data) {
                var doc = $(data);
                if (doc) {
                    var ids = ["#pjax-reload",'#next-page'];
                    var id;
                    while (id = ids.pop()) {
                        var $element = $(id);
                        if( $element.attr('data-replace')){
                            $element.html( doc.find(id).find('>*'));
                        }else{
                            $element.append( doc.find(id).find('>*'));
                        }

                    }
                }
                if (history_push) window.history.pushState(null, null, page_url);
            }
        });
    }
    if (isHhistoryApiAvailable()) {
        $(document).on('click','a[js-pjax]',function (e) {
            e.preventDefault();
            get_data(this.href.toString(), true);
        });
        $(window).bind('popstate', function () {
            get_data(location.pathname, false);
        });
    }
});